import { AVATAR_ICON_SIZE } from '@/constants/AvatarConstants';
import { classnames, getImageContain } from '@/helpers';
import { getSvgPath } from 'figma-squircle';

import Icon from '@/components/icons/Icon';
import { IconVariant } from '@/components/icons/types';
import { AvatarVariantIcon } from '../AvatarVariantIcon';
import { AvatarProps } from '../types';

const getStyle = (size): React.CSSProperties => {
  const { width, height, cornerRadius } = sizes[size];
  const path = getSvgPath({
    width,
    height,
    cornerRadius,
    cornerSmoothing: 1,
  });
  return {
    width,
    height,
    clipPath: `path('${path}')`,
  };
};

const sizes = {
  sm: {
    width: 48,
    height: 48,
    cornerRadius: 6,
  },
  md: {
    width: 56,
    height: 56,
    cornerRadius: 9,
  },
  lg: {
    width: 96,
    height: 96,
    cornerRadius: 18,
  },
};

const getThumbnailImageUrl = (url, size, slug) => {
  return getImageContain(url, size === 'xl' ? '94x94' : '60x60', slug);
};

const CompanyAvatar = ({
  variant = 'default',
  size = 'xl',
  alt,
  imgUrl,
  icon,
}: AvatarProps & { icon?: IconVariant }) => {
  return (
    <div className="w-3x relative inline-block">
      <div className={classnames('bg-surface_l4 flex items-center justify-center')} style={{ ...getStyle(size) }}>
        {imgUrl && (
          <img
            src={getThumbnailImageUrl(imgUrl, size, alt)}
            alt={alt}
            loading="lazy"
            className="relative z-10 h-full w-full"
            style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            onError={(e) => (e.currentTarget.src = '/images/bd-fallback-img60x60.jpg')}
          />
        )}
        {!imgUrl && <Icon variant={icon ?? 'shop'} color="black-500" size={AVATAR_ICON_SIZE[size]} />}
      </div>
      {variant !== 'default' && <AvatarVariantIcon size={size} variant={variant} />}
    </div>
  );
};

export default CompanyAvatar;
